// src/components/CodaOffline.jsx
//
// Barra che compare solo quando c'e' qualcosa da spedire o manca la rete.
//
// Un rapportino che resta sul dispositivo senza che nessuno lo dica e' un
// rapportino che il tecnico crede consegnato: deve vedersi.

import React from 'react';
import { osservaCoda, sincronizza } from '../offline/outbox';

export default function CodaOffline() {
  const [inAttesa, setInAttesa] = React.useState(0);
  const [online, setOnline] = React.useState(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );
  const [inCorso, setInCorso] = React.useState(false);
  const [esito, setEsito] = React.useState('');

  React.useEffect(() => osservaCoda(setInAttesa), []);

  React.useEffect(() => {
    const su = () => setOnline(true);
    const giu = () => setOnline(false);
    window.addEventListener('online', su);
    window.addEventListener('offline', giu);
    return () => {
      window.removeEventListener('online', su);
      window.removeEventListener('offline', giu);
    };
  }, []);

  const inviaOra = async () => {
    setInCorso(true);
    setEsito('');
    try {
      const r = await sincronizza();
      if (r.inviati > 0) {
        setEsito(`${r.inviati} ${r.inviati === 1 ? 'rapportino inviato' : 'rapportini inviati'}`);
      } else if (r.rimasti > 0) {
        setEsito('Non sono riuscito a inviare: riprovo da solo piu tardi');
      }
    } finally {
      setInCorso(false);
    }
  };

  if (online && inAttesa === 0) return null;

  return (
    <div
      className={`sticky top-0 z-50 w-full px-4 py-2 text-sm ${
        online ? 'bg-amber-100 text-amber-900' : 'bg-slate-700 text-white'
      }`}
    >
      <div className="max-w-6xl mx-auto flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold">
          {online ? 'Da inviare' : 'Sei senza rete'}
        </span>

        <span>
          {inAttesa === 0
            ? 'i rapportini che compili restano sul dispositivo e partono da soli quando torna la rete'
            : `${inAttesa} ${
                inAttesa === 1 ? 'rapportino non ancora inviato' : 'rapportini non ancora inviati'
              }`}
        </span>

        {esito && <span className="opacity-80">{esito}</span>}

        {online && inAttesa > 0 && (
          <button
            type="button"
            onClick={inviaOra}
            disabled={inCorso}
            className="ml-auto rounded bg-amber-700 px-3 py-1 text-white disabled:opacity-60"
          >
            {inCorso ? 'Invio...' : 'Invia ora'}
          </button>
        )}
      </div>
    </div>
  );
}
